module.exports = __webpack_public_path__ + "img/Hyperion.61e5c75b.jpg";